import React from 'react';
import type { Distribution } from '@/data/mockSegments';

interface DistributionCardProps {
  title: string;
  data: Distribution[];
  icon?: React.ReactNode;
  colorClass?: string;
}

export const DistributionCard: React.FC<DistributionCardProps> = ({
  title,
  data,
  icon,
  colorClass = 'bg-blue-500',
}) => {
  return (
    <div className="bg-v11-surface border border-v11-border rounded-lg p-4">
      {/* Header */}
      <div className="flex items-center gap-2 mb-4">
        {icon && <div className="text-v11-text-secondary">{icon}</div>}
        <h3 className="text-sm font-semibold text-v11-text-primary">{title}</h3>
      </div>

      {/* Distribution Bars */}
      <div className="space-y-3">
        {data.map((item) => (
          <div key={item.label}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm text-v11-text-primary">{item.label}</span>
              <span className="text-sm text-v11-text-secondary">
                {item.percentage}% ({item.value.toLocaleString()})
              </span>
            </div>
            <div className="w-full bg-v11-border rounded-full h-2 overflow-hidden">
              <div
                className={`h-full ${colorClass} transition-all duration-300`}
                style={{ width: `${item.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
